import Siema from 'siema'
blue.ready('reviews', '.reviews', rvw => {
	const slider = rvw.querySelector('.reviews-slider')
	const prev = rvw.querySelector('.reviews-prev')
	const next = rvw.querySelector('.reviews-next')
	let autoSlide;


	if(slider.childElementCount > 0){
		const slide = new Siema({
			selector: slider,
			easing: 'ease',
			duration: 500,
			loop: true,
			onInit: () => {
				autoSlide = setInterval(() => {
					slide.next()
				}, 12500)
			},
			onChange: () => {
				clearInterval(autoSlide)
				autoSlide = setInterval(() => {
					slide.next()
				}, 12500)
			}
		})

		prev.addEventListener('click', () => slide.prev())
		next.addEventListener('click', () => slide.next())	
	}	
})

blue.ready('review', '.reviews', rvw => {
	const shares = [...rvw.querySelectorAll('.review-cta')]
	const cancel = rvw.querySelector('.review-formCancel')

	const flip = (e, back) => {
		e.preventDefault();
		if (back) {
			rvw.classList.add('is-flipped')
		}
		else {
			rvw.classList.remove('is-flipped')
		}
	}
	shares.forEach(share => share.addEventListener('click', (e) => flip(e, true)))
	if (cancel) {
		cancel.addEventListener('click', (e) => flip(e, false))
	}
})